import React from "react";
import "./ApplyCredit.css";
import { AiOutlineRight } from "react-icons/ai";
import { useNavigate } from "react-router";

const ApplyCreditLandingPage = () => {
  const navigate = useNavigate();
  const tabs = [
    { title: "NBFC Onboarding", route: "https://loantap.in/journey/start/saveo-3", externalLink: true },
    { title: "CureBay Credit Onboarding", route: "/applyCredit/SaveoCredit" },
  ];

  const tabClick = (tab) => {
    if (tab?.externalLink) {
      window.open(tab.route, "_blank");
    } else {
      navigate(tab.route);
    }
  };
  return (
    <div className="apply-credit-parent-container">
      <div className="credit-landing-page-container">
        {tabs.map((tab) => {
          return (
            <div onClick={() => tabClick(tab)} className="account_item bg_white store_account_item display_flex space_btw">
              <div className="display_flex store-new-tag-container">{tab.title}</div>
              <div className="display_flex store-new-tag-container">
                <AiOutlineRight className="margin_10 color_secondary" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ApplyCreditLandingPage;
